export const sizesArray = ['lg', 'md', 'sm'] as const
export type Sizes = typeof sizesArray[number]

export const optionsSelect = [10, 30, 50, 100] as const
